import {
  leftZoneComponentRecoil,
  listToggleRecoil,
  softPhoneComponentRecoil,
  softPhoneTopTabRecoil,
  windowWidthRecoil,
} from '@/recoil/atoms/router/mainRouterRecoil';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import styled from 'styled-components';
import { useMsgRecoilReset } from '../hooks/customs/useMsgRecoilReset';

interface LogoWrapProps {
  windowWidth: number;
}

const LogoWrap = styled.h1<LogoWrapProps>`
  &.W {
    a {
      color: ${(props) => props.theme.colors.txt100};
    }
  }
  &.B {
    a {
      color: ${(props) => props.theme.colors.txt500};
    }
  }
  &.M {
    a {
      color: ${(props) => props.theme.colors.main};
    }
  }
  svg {
    width: ${(props) => (props.windowWidth > 768 ? '14rem' : '15rem')};
    height: ${(props) => (props.windowWidth > 768 ? '3rem' : '4rem')};
  }
  img {
    object-fit: contain;
    width: 100%;
    height: ${(props) => (props.windowWidth > 768 ? '8rem' : '6rem')};
  }
  a {
    text-align: center;
  }
  p {
    font-family: 'SBAggroB', sans-serif; /* 추가된 부분 */
    font-size: 1.2rem;
    margin-top: 0.4rem;
    font-weight: 700;
    text-align: center;
  }
`;

interface ILogo {
  // 새로고침 | 홈
  eType?: 'Reload' | 'Home';
  // 블랙 | 화이트 | 메인컬러
  sType?: 'B' | 'W' | 'M';
}

const Logo = ({ eType, sType }: ILogo) => {
  const [, setSoftPhoneTopTabS] = useRecoilState(softPhoneTopTabRecoil);
  const [, setSoftPhoneComponent] = useRecoilState(softPhoneComponentRecoil);
  const [, setListToggleS] = useRecoilState(listToggleRecoil);
  const setLeftZoneComponentS = useSetRecoilState(leftZoneComponentRecoil);

  const windowWidth = useRecoilValue(windowWidthRecoil);

  const { resetRecoil } = useMsgRecoilReset();
  const navigation = useNavigate();

  const moveInitPage = () => {
    navigation('/');
    resetRecoil();
    setSoftPhoneComponent('chatroom');
    setSoftPhoneTopTabS('0');
    setLeftZoneComponentS('address');
    setListToggleS(false);
    if (!(windowWidth > 768)) window.location.reload();
  };
  return (
    <LogoWrap className={`logo ${sType ?? 'B'}`} windowWidth={windowWidth}>
      {/* <Link to={'/'} onClick={eType === 'Reload' ? () => window.location.reload() : () => {}}> */}
      <Link to={'/'} onClick={eType === 'Home' ? () => moveInitPage() : () => window.location.reload()}>
        {/* <img src="/img/logo.png" alt="logoImage" /> */}

        <svg xmlns="http://www.w3.org/2000/svg" width="140" height="30" viewBox="-260 -140 1000 30" fill="none">
          <path
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="2"
            d="M194.1-227.5h-26c-19.5,3.3-34.6,13.3-45.5,30-12.2,23.9-16.5,49.3-13,76,.9,9.2,2.9,18.2,6,27,11.4,29.6,32.9,45,64.5,46h1c32.1-.6,54-16,65.5-46,8.9-30.1,8.6-60.1-1-90-9.7-23.4-26.9-37.7-51.5-43ZM211.6-98.5c-10.7,21.6-26.9,27.1-48.5,16.5-11.1-11.1-17.3-24.6-18.5-40.5-.7-10.7-.7-21.3,0-32,1.2-15.9,7.4-29.4,18.5-40.5,4-2.2,8-4,12-5.5,21.4-.4,34.6,9.9,39.5,31,5.5,24,4.5,47.6-3,71Z"
          />
          <path fill="currentColor" stroke="currentColor" strokeWidth="2" d="M268.1-196.5h30V-53.5h35v-170h-65v27Z" />
          <path
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="2"
            d="M464.1-162c-20.3-8-40.1-7.2-59.5,2.5-.5-12.3-.7-24.7-.5-37h84v-27h-119v97c10.7.2,21.3,0,32-.5,7.2-8.4,16.4-12.9,27.5-13.5,14.1-.1,24.4,5.9,31,18,5.6,15.1,2.8,28.3-8.5,39.5-27,12.8-47,5.7-60-21.5-8.6,3.8-17.2,7.3-26,10.5-1,.5-1.7,1.4-2,2.5,4,12.6,11.4,22.7,22,30.5,13.6,8.2,28.3,12.3,44,12.5h1c7.3-.6,14.6-1.8,22-3.5,23.7-7.2,38.7-22.7,45-46.5v-21c-4.4-19.2-15.4-33.4-33-42.5Z"
          />
          <path
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="2"
            d="M54.1-179c-1.3,4.6-2.8,9.1-4.5,13.5-13.2-13.2-29.2-19.5-48-19-38.1,4.2-59.9,25.2-65.5,63v10C-58.3-73.9-36.6-52.9,1.1-48.5h5c17.2-1.3,32-8,44.5-20,1.6,4.9,2.8,9.9,3.5,15h30v-126c-10-.2-20,0-30,.5ZM44.6-107.5c-5.6,22.9-20.1,33-43.5,30.5-19.5-5.7-29.5-18.9-30-39.5.7-20.7,10.7-34,30-40,32.2.4,46.7,16.7,43.5,49Z"
          />
        </svg>
        <p>개인과 기업을 위한 AICC 서비스</p>
      </Link>
    </LogoWrap>
  );
};

export default Logo;
